import SkeletonLoader from '../skeletonLoader/SkeletonLoader';
import WelcomePage from '../WelcomePage/WelcomePage';

import {useOktaAuth} from '@okta/okta-react';
import React, {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';

export const SecureRoute = () => {
  const {authState, oktaAuth} = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const isMobile = !!window.ReactNativeWebView;
    const hasCountryCode = !!localStorage.getItem('countryCode');

    if (!hasCountryCode && !isMobile) {
      navigate('/countrySelection');
      return;
    }
  }, []);

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      const urlParams = new URLSearchParams(globalThis.location.search);
      const hasCustId = !!urlParams.get('custid');
      const isReturningUser =
        localStorage.getItem('hasLoggedInBefore') === 'true';

      if (hasCustId || isReturningUser) {
        oktaAuth.setOriginalUri(
          globalThis.location.pathname + globalThis.location.search
        );
        oktaAuth.signInWithRedirect();
      }
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  useEffect(() => {
    if (authState?.isAuthenticated) {
      localStorage.setItem('hasLoggedInBefore', 'true');
    }
  }, [authState?.isAuthenticated]);

  if (!authState) {
    return (
      <div className="LoginSkeletonContatiner">
        <SkeletonLoader componentName="LoginPage" />
      </div>
    );
  }

  // if user came to app from different domain(like ops center) and not authenticated, then redirect to login page
  if (document.referrer && !authState.isAuthenticated) {
    oktaAuth.signInWithRedirect();
  }

  if (!document.referrer && !authState?.isAuthenticated) {
    return <WelcomePage />;
  }

  return <Outlet />;
};
